import React from "react";
import { useMediaQuery } from "@mui/material";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { Box, Button, Typography ,Grid,Paper} from "@mui/material";
import  { useEffect } from "react";
import { useRef } from "react";
import { useInView } from "framer-motion";

const MotionBox = motion(Box);
const MotionButton = motion(Button);
const MotionTypography = motion(Typography);



const serviceContents = [
    {
     description:`• Based on our knowledge of client needs and the skills they typically require, we identify and
 deliver the finest candidates available through a comprehensive, five-step recruiting process;
 Planning, Sourcing, Qualification, Closing and On-Boarding. 
    
    • Wehave an extensive database of the top technical professionals, their job profiles, salary
 structure, where to find them and when they will be available. We understand their
 preferences, and what it takes to get them on-board.`,
 image: "/image/img2.jpg",
    },
    {
       description: `
      • We qualify resource candidates through careful analysis of their skills, their preferences and
 their work history to ensure you get a qualified candidate who meets your specified skill
 qualifications, culture and cost and is committed to your project. 
      • We communicate with our candidates continuously throughout the staffing process which
 results in higher success in closing the selected candidate.`,
  
     
      image: "/image/client.png",
    },
    {
     description: `•We customize our on-boarding process for each client’s unique needs so that resources show
 up on time, ready to go from day one.  
      
      •We believe timely and effective communication with our clients and our professional
 consultants is a key component to achieving successful project completion through sustained
 consultant performance and retention until project completion. We are fully committed to
 being a valued partner to you for all of your staffing resources`,
 image: "/image/hand.jpg",
    },
    {
      description: `• We take time to understand your company, and its culture. This helps us assess your
 requirements, and develop a plan to get the right talent. 
       • We work in wide variety of models. We work with most of the leading MSP organizations
  and VMS software systems. We work direct with clients who want both onsite and offshore
  IT talent.
      • We have a comprehensive network of IT professionals, and we use our referral-based
 sourcing to improve our selectivity, and effectiveness to choose the top talent for any given
 requirement.  `,
  image: "/image/img1.jpg",
     },
    
  ];
  

  


 


  



const steps = [
    {
      title: "Job Order",
      points: ["Analyze Requirement", "Prioritize Needs", "Prepare Job Requisition"],
      buttonPosition: "bottom-right",
    },
    {
      title: "Sourcing Strategy",
      points: ["In-house Database", "Social Recruiting", "Job Boards", "Referrals"],
      buttonPosition: "top-right",
    },
    {
      title: "Hiring",
      points: ["Skill Matching", "SME Pre-screening", "Negotiate Salary", "Arrange Interview"],
      buttonPosition: "bottom-right",
    },
    {
      title: "On-boarding",
      points: ["Reference Checks", "Background Screening"],
      buttonPosition: "top-right",
    },
  ];

const Itstaffing = () => {
    const isMobile = useMediaQuery("(max-width:780px)");

    const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { triggerOnce: false, margin: "-100px" });

  


     useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);


  return (
     <>
          {/* First Section - Background Image */}
          <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh", // Use minHeight instead of fixed height
        backgroundImage: `url("/image/it2.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        color: "white",
        overflow: "hidden", // Prevents content from spilling over
      }}
    >
      {/* Dark overlay for readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      />
    
      {/* Content Box */}
      <Box
        sx={{
          position: "relative",
         maxWidth: "700px",
          marginLeft: { xs: "3%", md: "8%" },
          marginTop: { xs: "15%", md: "10%" }, // Reduce margin to avoid overflow
          zIndex: 1,
          padding: 4,
        //  maxWidth: { xs: "95%", md: "80%" }, // Adjust width based on screen size
          
        }}
      >
        <Typography 
          variant="h3" 
          sx={{ 
            fontWeight: "bold", 
            mb: 2, 
            fontSize: { xs: "28px", md: "42px" }, // Reduce size slightly for better fit
          }}
        >
          IT Staffing
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            fontSize: { xs: "14px", md: "18px" }, 
            maxWidth: "100%", 
            wordBreak: "break-word", 
            lineHeight: 1.5, 
          }}
        >
        Tech Informatic Solutions is a premier provider of IT staffing solutions to Fortune 500 customers. Whether it is
 providing just a few resources or staffing entire project teams involving hundreds of resources,
 Tech Informatic Solutions IT staffing solutions help clients with the right talent, skills and competencies when they need
 them. We provide clients exceptional IT talent to meet their demanding technology initiatives at both
 local and national levels. Tech Informatic Solutions exceeds client expectations through highly effective processes for
 recruiting, screening, testing, and talent engagement. Our commitment to servicing our clients is
 evident by repeat business from existing clients.
        </Typography>
      </Box>
    </Box>





{/*second section */}


   


{isMobile ? (
   
    <Box
      ref={sectionRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "93vw",
        padding: "20px",
        gap: "20px",
        mt: 8,
        mb: 8,
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      {steps.map((step, index) => (
        <MotionBox
          key={index}
          sx={{
            position: "relative",
            textAlign: "left",
            width: "90%",
            maxWidth: "400px",
            margin: "0 auto",
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: index * 0.5, duration: 0.8, ease: "easeInOut" }}
        >
          <MotionBox
            sx={{
              width: "100%",
              minHeight: "150px",
              borderRadius: "10px",
              border: "2px solid #333",
              padding: "15px",
              backgroundColor: "#1F6788",
              boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              transformStyle: "preserve-3d",
              transition: "transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out",
              margin: "0 auto",
              "&:hover": {
                transform: "translateZ(40px)",
                boxShadow: "15px 15px 30px rgba(0, 0, 0, 0.8)",
              },
            }}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
            transition={{ delay: index * 0.7, duration: 0.8, ease: "easeInOut" }}
          >
            <MotionBox sx={{ paddingTop: "15px" }}>
              {step.points.map((point, i) => (
                <MotionTypography
                  key={i}
                  variant="body1"
                  sx={{ mb: 1, color: "white" }}
                  initial={{ opacity: 0, x: -20 }}
                  animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
                  transition={{ delay: index * 0.9 + i * 0.3, duration: 0.5, ease: "easeOut" }}
                >
                  • {point}
                </MotionTypography>
              ))}
            </MotionBox>

            <MotionButton
              variant="contained"
              sx={{
                position: "absolute",
                bottom: "-12px",
                right: "10px",
                backgroundColor: "orange",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "14px",
                padding: "5px 8px",
                borderRadius: "6px",
              }}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
              transition={{ delay: index * 1, duration: 0.6, ease: "easeInOut" }}
            >
              {step.title}
            </MotionButton>
          </MotionBox>
        </MotionBox>
      ))}
    </Box>
) : (
  // Desktop View (Structured Style)
  <Box
  ref={sectionRef}
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "nowrap",
    overflowX: "auto",
    width: "100vw",
    padding: "20px",
    gap: "50px",
    position: "relative",
    mt: 8,
    mb: 8,
    perspective: "1200px",
  }}
>
  {steps.map((step, index) => (
    <MotionBox 
      key={index} 
      sx={{ position: "relative", textAlign: "left", flexShrink: 0 }}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
      transition={{ delay: index * 0.5, duration: 1, ease: "easeInOut" }}
    >
      {/* 3D Box */}
      <MotionBox
        sx={{
          width: "200px",
          minHeight: "150px",
          borderRadius: "10px",
          border: "2px solid #333",
          padding: "15px",
          backgroundColor: "#1F6788",
          boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          transformStyle: "preserve-3d",
          transform: "rotateX(15deg) translateZ(20px)",
          transition: "transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out",
          "&:hover": {
            transform: "rotateX(0deg) translateZ(40px)",
            boxShadow: "15px 15px 30px rgba(0, 0, 0, 0.8)",
          },
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
        transition={{ delay: index * 0.7, duration: 1, ease: "easeInOut" }}
      >
        {/* Bullet Points */}
        <MotionBox 
          sx={{ paddingTop: "15px" }}
          initial={{ opacity: 0, x: -20 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
          transition={{ delay: index * 0.9, duration: 0.8, ease: "easeOut" }}
        >
          {step.points.map((point, i) => (
            <MotionTypography 
              key={i} 
              variant="body1" 
              sx={{ mb: 1, color: "white" }}
              initial={{ opacity: 0, x: -20 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
              transition={{ delay: index * 0.9 + i * 0.3, duration: 0.5, ease: "easeOut" }}
            >
              • {point}
            </MotionTypography>
          ))}
        </MotionBox>


       




        {/* Button */}
        <MotionButton
          variant="contained"
          sx={{
            position: "absolute",
            [step.buttonPosition === "bottom-right" ? "bottom" : "top"]: "-12px",
            right: "-12px",
            backgroundColor: "orange",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "14px",
            padding: "5px 8px",
            borderRadius: "6px",
            transition: "transform 0.3s ease-in-out",
            transform: "translateZ(10px)",
            "&:hover": { backgroundColor: "#0056b3", transform: "translateZ(20px)" },
            "&:active": {
              transform: "translateZ(0px)",
              boxShadow: "inset 2px 2px 5px rgba(0, 0, 0, 0.3)",
            },
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
          transition={{ delay: index * 1.2, duration: 0.6, ease: "easeInOut" }}
        >
          {step.title}
        </MotionButton>
      </MotionBox>

      {/* Arrow */}
      {index !== steps.length - 1 && (
        <MotionBox
          sx={{
            position: "absolute",
            width: "70px",
            height: "40px",
            top: "50%",
            right: "-50px",
            transform: "translateY(-50%)",
            backgroundImage: `url("/image/uparrow.jpg")`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          initial={{ opacity: 0, x: -20 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
          transition={{ delay: index * 1.5, duration: 0.8, ease: "easeOut" }}
        />
      )}
    </MotionBox>
  ))}
</Box>





)}


{/* Paragraph Below the Steps Section */}


<Box
  sx={{
    width: "100%",
    padding: "20px",
   // backgroundColor: "#f5f5f5",
    //boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.2)",
    boxSizing: "border-box"
  }}
>
  
  <Typography 
    variant="body1" 
    sx={{ color: "black", lineHeight: "1.6", textAlign: "justify", mx: 3,fontSize: { xs: "14px", md: "18px" } }}
  >
   We help find the right people for the right job. We understand how critical it is to match the right talent
 to the specified job. In today’s fast paced business world. We know time management is of utmost
 importance. We help you utilize your time more effectively by offering the best talent in the market
 which saves hiring managers time and energy spent on screening candidates. We take a hands-on
 approach and do all of the legwork for you. Our Staffing Team is professional, compassionate and
 stringently follows hiring procedures and guidelines. Our staffing professionals keep current with the
 latest trends in the market. We also use social network platforms to find and recruit the top talent
 available. We have built a world class Recruiting Engine to compile a talent base of pre-screened
 candidates available for rapid placement. This talent acquisition model encompasses a sophisticated
 resource management database and a centralized quick response team specialized in sourcing and
 qualifying the best candidates through best practices
  </Typography>
</Box>





<Box 
  sx={{ 
    p: isMobile ? 3 : 7, 
    textAlign: "justify", 
    backgroundColor: "white", 
    width: "100%",
    overflow: "hidden", // Ensures content stays within the container
    boxSizing: "border-box"
  }}
>
  <Grid 
    container 
    justifyContent="center" 
    alignItems="stretch" 
    spacing={3} 
    sx={{ 
      mt: 4, 
      mb: 4, 
      px: isMobile ? 2 : 4, // Equal left and right margins in mobile view
      maxWidth: "100%", // Prevents content from overflowing
      margin: "0 auto" // Ensures everything is centered
    }}
  >
    {serviceContents.map((service, index) => (
      <Grid 
        item 
        xs={12} 
        sm={6} 
        md={3} 
        key={index} 
        sx={{ 
          display: "flex",
          maxWidth: "100%" // Ensures items don't exceed container width
        }}
      >
        <Paper
          elevation={5}
          sx={{
            position: "relative",
            borderRadius: "15px",
            width: "100%",
            minHeight: "450px",
            height: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${service.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: "all 0.5s ease-in-out",
            "&:hover": {
              backgroundImage: `linear-gradient(#1F6788, #1F6788), url(${service.image})`,
            },
            "&:hover .content": { opacity: 1 },
            "&:hover .default-title": { opacity: 0 },
            "& .content": { opacity: 0, transition: "opacity 0.5s ease-in-out" },
            "& .default-title": { opacity: 1, transition: "opacity 0.5s ease-in-out" },
          }}
        >
          {/* Content Inside the Paper */}
          <Box className="content" sx={{ width: "100%", textAlign: "center", mt: 2 }}>
  <Box sx={{ mt: 1, px: 2 }}>
    {service.description.split("•").map((point, index) =>
      point.trim() ? (
        <Typography
          key={index}
          variant="body2"
          sx={{
            fontFamily: "Roboto",
            lineHeight: "1.8",
            display: "flex",
            textAlign: "left",
            fontSize: isMobile ? "16px" : "18px",
            color: "white",
            wordSpacing: "0em",
            mb: 2, // Added margin-bottom for spacing
          }}
        >
          <span
            style={{
              fontSize: isMobile ? "20px" : "22px",
              fontWeight: "bold",
              color: "orange",
              marginRight: "8px",
              display: "inline-block",
            }}
          >
            •
          </span>
          <span style={{ flex: 1 }}>{point}</span>
        </Typography>
      ) : null
    )}
  </Box>
</Box>

        </Paper>
      </Grid>
    ))}
  </Grid>
</Box>









<Footer />
  
    </>
  );
};
export default Itstaffing;
